import styles from './FieldHint.module.css';

import { Spinner } from 'components/Spinner/Spinner';

export interface FieldHintProps {
  /** The value to display. */
  value?: string;
  /** The aria-valuetext value of the spinner component. */
  spinnerAriaValueText: string;
  /** true if the field hint is loading; otherwise, false. The default is false. */
  loading?: boolean;
}

/** Represents a component to show a hint for an input element. */
export function FieldHint({ value, spinnerAriaValueText, loading }: FieldHintProps) {
  return (
    <span className={styles['field-hint']}>
      {value && <>{value}</>}
      {!value && loading && <Spinner ariaValueText={spinnerAriaValueText} />}
    </span>
  );
}
